import "../../node_modules/.pnpm/vue@3.5.13_typescript@4.9.5/node_modules/vue/dist/vue.runtime.esm-bundler.es.js";
import xss from "xss";
import WsIcon from "../assets/WsIcon.vue.es.js";
import { UI_SIZE, UI_VARIANT } from "./WsStateBanner.enum.es.js";
import { defineComponent, computed, resolveComponent, createElementBlock, createElementVNode as createBaseVNode, createBlock, createCommentVNode, createVNode, withCtx, createTextVNode, openBlock } from "../../node_modules/.pnpm/@vue_runtime-core@3.5.13/node_modules/@vue/runtime-core/dist/runtime-core.esm-bundler.es.js";
import { ref, unref } from "../../node_modules/.pnpm/@vue_reactivity@3.5.13/node_modules/@vue/reactivity/dist/reactivity.esm-bundler.es.js";
import { toDisplayString, normalizeClass } from "../../node_modules/.pnpm/@vue_shared@3.5.13/node_modules/@vue/shared/dist/shared.esm-bundler.es.js";
const _hoisted_1 = { class: "ws-state-banner-inner-wrapper flex row" };
const _hoisted_2 = {
  key: 1,
  class: "ws-state-banner__content"
};
const _hoisted_3 = {
  key: 0,
  class: "ws-state-banner__title"
};
const _hoisted_4 = {
  key: 1,
  class: "ws-state-banner__text"
};
const _hoisted_5 = ["innerHTML"];
const _hoisted_6 = {
  key: 3,
  class: "ws-state-banner__closable justify-end"
};
const _hoisted_7 = {
  key: 0,
  class: "flex justify-end"
};
const _hoisted_8 = ["href"];
const _sfc_main = /* @__PURE__ */ defineComponent({
  __name: "WsStateBanner",
  props: {
    size: { type: String, default: UI_SIZE.LARGE },
    type: { type: String, default: UI_VARIANT.DEFAULT },
    closable: { type: Boolean, default: false },
    icon: { type: Boolean, default: false },
    title: { type: String, default: "" },
    text: { type: String, default: "" },
    button: { type: String, default: "" },
    headerIcon: { type: String, default: "" },
    portalSlots: {
      type: Array,
      default: null
    }
  },
  emits: ["close"],
  setup(__props, { emit: __emit }) {
    const props = __props;
    const emit = __emit;
    const isClosed = ref(false);
    const getIcon = () => {
      switch (props.type) {
        case UI_VARIANT.NEUTRAL:
          return "success_full";
        case UI_VARIANT.SUCCESS:
          return "success_full";
        case UI_VARIANT.WARNING:
          return "alert_triangle_full";
        case UI_VARIANT.ERROR:
          return "alert_circle_full";
        case UI_VARIANT.DEFAULT:
        default:
          return "info_full";
      }
    };
    const closeBanner = () => {
      isClosed.value = true;
      emit("close");
    };
    const buttonLabel = computed(() => {
      return props.button ? JSON.parse(props.button).label : "";
    });
    const buttonUrl = computed(() => {
      return props.button ? JSON.parse(props.button).url : "";
    });
    const buttonIcon = computed(() => {
      return props.button ? JSON.parse(props.button).icon : "";
    });
    const hasTitleSlot = computed(() => {
      var _a;
      return (_a = props.portalSlots) == null ? void 0 : _a.includes("title");
    });
    const hasTextSlot = computed(() => {
      var _a;
      return (_a = props.portalSlots) == null ? void 0 : _a.includes("text");
    });
    const hasDefaultSlot = computed(() => {
      var _a;
      return (_a = props.portalSlots) == null ? void 0 : _a.includes("default");
    });
    return (_ctx, _cache) => {
      const _component_portal_slot = resolveComponent("portal-slot");
      return !isClosed.value ? (openBlock(), createElementBlock("div", {
        key: 0,
        ref: "banner",
        class: normalizeClass(["ws-state-banner column", `${__props.size} ${__props.type}`])
      }, [
        createBaseVNode("div", _hoisted_1, [
          props.icon ? (openBlock(), createBlock(WsIcon, {
            key: 0,
            name: getIcon(),
            size: 22,
            wrap: "",
            class: "ws-state-banner__icon"
          }, null, 8, ["name"])) : createCommentVNode("", true),
          !hasDefaultSlot.value ? (openBlock(), createElementBlock("div", _hoisted_2, [
            hasTitleSlot.value || props.title ? (openBlock(), createElementBlock("div", _hoisted_3, [
              createVNode(_component_portal_slot, {
                slot: _ctx.$slots.title,
                "component-id": _ctx.$attrs["component-id"],
                name: "title"
              }, {
                default: withCtx(() => [
                  createTextVNode(toDisplayString(props.title), 1)
                ]),
                _: 1
              }, 8, ["slot", "component-id"])
            ])) : createCommentVNode("", true),
            hasTextSlot.value || props.text ? (openBlock(), createElementBlock("p", _hoisted_4, [
              createVNode(_component_portal_slot, {
                slot: _ctx.$slots.text,
                "component-id": _ctx.$attrs["component-id"],
                name: "text"
              }, {
                default: withCtx(() => [
                  createBaseVNode("div", {
                    innerHTML: unref(xss)(props.text)
                  }, null, 8, _hoisted_5)
                ]),
                _: 1
              }, 8, ["slot", "component-id"])
            ])) : createCommentVNode("", true)
          ])) : (openBlock(), createBlock(_component_portal_slot, {
            key: 2,
            slot: _ctx.$slots.default,
            "component-id": _ctx.$attrs["component-id"],
            name: "default"
          }, null, 8, ["slot", "component-id"])),
          props.closable ? (openBlock(), createElementBlock("div", _hoisted_6, [
            createBaseVNode("button", {
              class: "close-button self-start q-px-sm q-py-sm",
              onClick: closeBanner
            }, [
              createVNode(WsIcon, {
                name: "close",
                size: 14
              })
            ])
          ])) : createCommentVNode("", true)
        ]),
        props.button ? (openBlock(), createElementBlock("div", _hoisted_7, [
          createBaseVNode("a", {
            class: "q-btn self-end",
            href: buttonUrl.value
          }, [
            createVNode(WsIcon, { name: buttonIcon.value }, null, 8, ["name"]),
            createTextVNode(" " + toDisplayString(buttonLabel.value), 1)
          ], 8, _hoisted_8)
        ])) : createCommentVNode("", true)
      ], 2)) : createCommentVNode("", true);
    };
  }
});
export {
  _sfc_main as default
};
//# sourceMappingURL=WsStateBanner.vue.es2.js.map
